export default __webpack_public_path__ + "static/Tori-Cooper-hero-02cc9cf0943a2158878079d9410fb6e1.jpg";